export const pagePublishedState = {
	pageJustPublished: false,
};
